<template>
    <div>
        <!-- Slot Search -->
        <div class="mb-1 ml-2 mr-2">
            <slot></slot>
        </div>
        <!--  -->
        <div v-if="loadingApp == false">
            <div v-if="data.data.length > 0">
                <div v-for="(dataItem, date) in groupByDate" :key="date">
                    <!-- item -->
                    <div class="listview-title" style="background-color:#F3F4F5;padding: 2px 16px;font-weight:normal;">{{date}}</div>
                    <ul class="listview image-listview-product full ml-0 mr-0">
                        <li v-for="item in dataItem" :key="item.id">
                            <router-link :to="{name:'transaction.deposit.show', params:{id:item.id}}" class="item pl-3 pr-3" >
                                <div class="imageWrapper mr-1">
                                    <img v-if="item.payment != null &&
                                        item.payment.payment_logo != null" 
                                        v-lazyload :src="require('@/assets/Loader-2.png')" :data-src="VUE_ENV.VUE_APP_ASSET_URL+'/img/payment/'+item.payment.payment_logo" alt="image" class="imaged w36">
                                    <img v-else v-lazyload :src="require('@/assets/Loader-2.png')" :data-src="require('@/assets/other.png')" alt="image" class="imaged w36">
                                </div>
                                <div class="in">
                                    <div style="width: 90%;">
                                        <h4>{{item.payment.payment_name}}</h4>
                                        <footer>{{ item.payment_number }}</footer>
                                    </div>
                                    <span class="text-muted text-right">
                                        <h5 class="mb-0" style="font-weight:normal;">Rp {{ item.nominal_transfer | rupiah }}</h5>
                                        <strong class="text-success" style="font-weight:bold;" v-if="item.status == 'SUCCESS'">Berhasil</strong>
                                        <strong class="text-warning" style="font-weight:bold;" v-if="item.status == 'WAITING'">Menunggu</strong>
                                        <strong class="text-danger" style="font-weight:bold;" v-if="item.status == 'EXPIRED'">Kadaluarsa</strong>
                                    </span>
                                </div>
                            </router-link>
                        </li>
                    </ul>
                </div>
                <!-- * item -->
                <div class="m-2 text-center" v-if="data.next_page_url">
                    <ButtonLoader :loading="loadingButton" :styled="'btn btn-primary rounded mr-1 mb-1'" @click.native="$emit('paginate')">Lihat lebih banyak</ButtonLoader>
                </div>
            </div>
            <div class="text-center mt-5 mb-5" v-else>
                <img :src="require('@/assets/image/404.svg')" alt="404" class="w-75 mb-3"><br>
                <i>Transaksi belum tersedia</i>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex';
import moment from 'moment'
moment.locale('id')
export default {
    props:['data','loadingButton','loadingApp'],
    computed:{
        ...mapState(['VUE_ENV']),
        groupByDate(){
            return this.groupBy(this.data.data, 'created_at')
        }
    }, 
    methods: {
        groupBy(array, key){
            const result = {}
            array.forEach(item => {
                let date = moment(item[key]).format('ll');
                if (!result[date]){
                result[date] = []
                }
                result[date].push(item)
            })
            return result
        }
    }
}
</script>